import capitalize from 'lodash/capitalize';

const AB_TEST_IDS = ['abtest', 'c4s-ab-test'];
const ROLLOUT_IDS = ['rollout', 'c4s-rollout'];
const ANALYSIS_IDS = ['analysis', 'reanalysis', 'spotify-analysis'];
const STATIC_CONFIG_IDS = ['static-config'];

type FormatOptions = {
  capitalize?: boolean;
  pluralize?: boolean;
};

export const useFormatWorkflowDisplayName = () => {
  // Should be updated to use the workflowExtensions from the config
  // Need to make sure the workflowExtensions are populated immediately
  // when running in Portal

  return (workflowId: string, options: FormatOptions = {}) => {
    const { capitalize: shouldCapitalize, pluralize } = options;
    let label = workflowId;

    if (AB_TEST_IDS.includes(workflowId)) {
      label = pluralize ? 'A/B tests' : 'A/B test';
    } else if (ROLLOUT_IDS.includes(workflowId)) {
      label = pluralize ? 'rollouts' : 'rollout';
    } else if (ANALYSIS_IDS.includes(workflowId)) {
      label = pluralize ? 'analyses' : 'analysis';
    } else if (STATIC_CONFIG_IDS.includes(workflowId)) {
      label = pluralize ? 'static configs' : 'static config';
    }

    // Skip capitalize() when the label already contains uppercase letters
    // (e.g. "A/B test"), since lodash capitalize would lowercase them.
    if (shouldCapitalize && !/[A-Z]/.test(label)) {
      return capitalize(label);
    }
    return label;
  };
};
